export default {
  title: 'טעינת נתונים',
  action: 'קבצים שנטענו',
  subtitle: 'מלא את כל הנתונים הנדרשים על מנת לטעון נתונים למערכת',
  dropzone: {
    title: 'גרור את הקבצים, או לחץ כאן כדי לבחור אותם',
    subtitle: 'ניתן להעלות קבצים בגודל של עד',
  },
  notifications: {
    success: 'הצלחה בטעינת הקובץ {1}',
    validationError: 'הקובץ לא נקלט כי נמצאו {1} שגיאות ',
    internalError: 'כשלון בטעינת הקובץ, אנא רענן את הדף',
  },
  form: {
    company: 'חברה מנהלת',
    files: 'קובץ',
    noFile: 'ללא קובץ',
    noFileDescription: 'יצרן זה אינו שולח קובץ — הזן את הנתונים ידנית.',
    noManualRules: 'ליצרן זה אין חוקי הזנה ידנית. קבצים נטענים בעמוד טעינת הנתונים.',
    month: 'חודש',
    year: 'שנה',
    action: 'טעינת נתונים',
    referenceYear: 'בגין שנת',
  },
  errors: {
    fileTitleInvalid: 'שם הקובץ שנבחר אינו תואם את שמות הקבצים הנדרשים',
    required: 'שדה חובה',
    'file-invalid-type': 'סוג המסמך לא תואם את הסוג הנדרש',
    'file-too-large': 'המסמך גדול מדי',
  },
};
